import { Box } from "@mantine/core";

import { spacing } from "#app/theme/v2/spacing";

import type { ReactNode } from "react";

type BulkActionBarOverlayProps = {
  visible: boolean;
  children: ReactNode;
};

const BulkActionBarOverlay = ({ visible, children }: BulkActionBarOverlayProps) => {
  if (!visible) {
    return null;
  }

  return (
    <Box
      style={{
        position: "absolute",
        top: `-${spacing[16]}`,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 10,
      }}
    >
      {children}
    </Box>
  );
};

export { BulkActionBarOverlay };
